// MARK://dhk8/admin-shell/lib/clients/print-stations
// Estaciones de impresión (dhk8-pos-printing).
//
// Lectura usada por el editor Catálogo → Categorías para el dropdown "Estación de
// impresión" que mapea una ProductCategory a una PosPrintStation (schema dhk8_pos),
// vía `ProductCategory.stationId`.
//
// F3.4 / ADR-0009: lectura por el grafo (pos-printing `printStations`), tenant del
// JWT (antes era REST `/v1/printing/stations?tenantId=` con el tenant del cliente).
// Escrituras (crear/editar/borrar estación) siguen REST.

import { PREVIEW_STUB, mock } from '../env.js'
import { gqlClient } from '../gql.js'
import { AdminPrintStationsQuery } from '../queries/print-stations.queries.js'

export interface PrintStation {
  id: string
  tenantId: string
  branchId?: string | null
  name: string
  sortOrder: number
}

// PREVIEW seed — deterministic dummy so the dropdown is non-empty when the
// backend is offline.
const PREVIEW_SEED: PrintStation[] = [
  { id: 'stn-cocina',   tenantId: 'preview', name: 'Cocina', sortOrder: 1 },
  { id: 'stn-barra',    tenantId: 'preview', name: 'Barra',  sortOrder: 2 },
]

export async function listStations(signal?: AbortSignal): Promise<PrintStation[]> {
  if (PREVIEW_STUB) return mock(PREVIEW_SEED)
  const ctx = signal ? { fetchOptions: { signal } } : undefined
  const res = await gqlClient.query(AdminPrintStationsQuery, {}, ctx).toPromise()
  if (res.error) throw res.error
  return (res.data?.printStations ?? []).map((s) => ({
    id: s.id, tenantId: s.tenantId, branchId: s.branchId, name: s.name, sortOrder: s.sortOrder,
  }))
}
